import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../../services/HttpInterceptor';
import {
    RouteComponentProps, Link
} from "react-router-dom";
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import { observable } from 'mobx';

interface IndexCutOffsProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}
@observer export default class IndexCutOffs extends React.Component<IndexCutOffsProps> {

    @observable private cutoffs: any;
    @observable private isLoaded = false;
    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        http.get('/api/cutoff/read').then((response:any) => {
            this.cutoffs = response.data.response;
            this.isLoaded = true;
        }).catch(() => {
            toast.error("Error cargando fechas de corte");
        });
    }

    render() {
        if (!this.isLoaded) {
            return null;
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-primary">
                                <h4 className="card-title ">Lista de fechas de corte</h4>
                                <p className="card-category">
                                    Fechas de corte de contratos
                                </p>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <Link to={`/contratos/cortes/nuevo`}>
                                            <button className="btn btn-info btn-lg  pull-right">
                                                <i className="material-icons">account_circle</i> Nueva Fecha
                                                <div className="ripple-container"></div>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead className=" text-primary">
                                            <tr>
                                                <th>Dia de Corte</th>
                                                <th>Contratos</th>
                                                <th className="text-right">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.cutoffs.map((cutoff: any, index: any) => {
                                                    return (
                                                        <Fragment key={index}>
                                                            <tr>
                                                                <td>{cutoff.date}</td>
                                                                <td>{cutoff.contracts}</td>
                                                                <td className="td-actions text-right">
                                                                <Link to={`/contratos/cortes/ver/${cutoff.id}`}>
                                                                        <button style={{ margin: 5 }} type="button" className="btn btn-info">
                                                                            <i className="material-icons">visibility</i>
                                                                        </button>
                                                                    </Link>
                                                                    <Link to={`/contratos/cortes/${cutoff.id}`}>
                                                                        <button style={{ margin: 5 }} type="button" className="btn btn-success">
                                                                            <i className="material-icons">edit</i>
                                                                        </button>
                                                                    </Link>

                                                                    <button onClick={() => this.deleteClient(cutoff.id, index)} style={{ margin: 5 }} type="button" className="btn btn-danger" >
                                                                        <i className="material-icons">close</i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </Fragment>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }

    private deleteClient = (id: any, index: any): void => {
        swal({
            title: "Confirmar acción",
            text: "¿Estas seguro que quieres borrar la fecha de corte?",
            icon: "warning",
            dangerMode: true,
        })
            .then(willDelete => {
                if (willDelete) {
                    const deleteObject = JSON.stringify({
                        id
                    });
                    http.post(`/api/cutoff/delete`, deleteObject)
                        .then(() => {
                            this.cutoffs.splice(index, 1);
                            toast.success("Fecha de corte borrada correctamente");
                        }).catch((error) => {
                            if (error.includes("foreign")) {
                                toast.error("Error al borrar: Hay contratos ligados a esta fecha");
                            } else {
                                toast.error("Error borrando fecha de corte");
                            }
                        })
                }
            });
    }
}